import React, { useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router";
import logo from "../../assets/images/logo_dark.png";

const ThankYou = () => {
    const navigate = useNavigate();
    const [loading, setLoding] = useState(false);
    function gotoLogin() {
        navigate("/login")
    }

    return (
        <>
            <div className="auth_wrapper auth_layout">
                <div className="row h-100 flex-row-reverse g-0">
                    <div className="col-lg-6 d-none d-lg-block">
                        <div className="auth_left_container">

                        </div>
                    </div>
                    <div className="col-lg-6 h-100">
                        <div className="auth_right_container">
                            <div className="auth_container">
                                <div className="top_welcoming_text">
                                    <div className="logo text-center mb-4">
                                        <a href="https://binoxbargains.com/">
                                            <img src={logo} alt="" />
                                        </a>
                                    </div>
                                    <h3 className="text-center">Thanks for sigining up!</h3>
                                    <p className="text-center">You Can Access your Partner Control Panel with your Credential.</p>
                                </div>


                                <Button sx={{
                                    backgroundColor: "#FFBD05", boxShadow: "none", borderRadius: "8px", "&:hover": {
                                        backgroundColor: "#FFBD05",
                                        boxShadow: "none",
                                    }
                                }} onClick={gotoLogin} className="mt-4 text-white app_text_16_semibold app_btn_lg" loading={loading} loadingPosition="end" variant="contained">
                                    Login
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ThankYou;